import React from 'react';
import { Link } from 'react-router-dom';
import { MetaHead } from '../components/MetaHead';
import { COMPANY_INFO } from '../data/scrapedData';

export function ForbiddenPage() {
  return (
    <>
      <MetaHead title="Adgang nægtet (403) - Den Selvejende Institution Midtgaarden" description="Du har ikke adgang til denne side." />

      <section className="min-h-[60vh] py-20 bg-[#F8FAFC] flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          
          <div className="w-16 h-16 rounded-full bg-amber-500/10 text-amber-700 flex items-center justify-center text-2xl font-bold mx-auto">
            403
          </div>

          <h1 className="text-3xl font-extrabold text-[#1C1C1E] tracking-tight">
            Ingen adgang til denne side
          </h1>

          <p className="text-sm sm:text-base text-[#1C1C1E]/75 leading-relaxed">
            Du har ikke tilladelse til at tilgå den anmodede side. Hvis du mener dette er en fejl, er du velkommen til at kontakte os per telefon eller e-mail.
          </p>

          <div className="pt-4 flex justify-center">
            <Link
              to="/"
              className="bg-[#1C1C1E] hover:bg-[#000000] text-white px-6 py-3 rounded-full font-semibold text-sm transition-colors text-center"
            >
              Gå til Forside
            </Link>
          </div>

          <div className="pt-6 border-t border-[#1C1C1E]/10 flex flex-col sm:flex-row items-center justify-center gap-4 text-xs font-medium">
            <a href={COMPANY_INFO.phoneTel} className="text-[#3885B8] hover:underline flex items-center gap-1.5 whitespace-nowrap">
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <span>Ring 75 17 20 80</span>
            </a>

            <a href={COMPANY_INFO.emailMailto} className="text-[#3885B8] hover:underline flex items-center gap-1.5 whitespace-nowrap">
              <i className="fa-solid fa-envelope" aria-hidden="true" />
              <span>Skriv til os</span>
            </a>
          </div>

        </div>
      </section>
    </>
  );
}
